import { IIncidentRow } from 'types/incidents.interface'

export const MOCK_INCIDENTS: IIncidentRow[] = [
  {
    id: 1,
    severity: 'L1',
    timestamp: '2024-05-13 04:00',
    title: 'Near-miss: vehicle proximity alarm',
    location: 'SECTION: 1 zone(s)',
    status: 'open',
  },
  {
    id: 2,
    severity: 'L4',
    timestamp: '2024-05-12 10:20',
    title: 'Equipment rollover at Pit N-1-A',
    location: 'PIT: 1 zone(s) - cascade applied',
    status: 'investigating',
  },
  {
    id: 3,
    severity: 'L3',
    timestamp: '2024-05-11 14:10',
    title: 'Rock fall in Block N-2',
    location: 'BLOCK: 1 zone(s) - cascade applied',
    status: 'acknowledged',
  },
  {
    id: 4,
    severity: 'L2',
    timestamp: '2024-05-11 09:45',
    title: 'Hand laceration during maintenance',
    location: 'PIT: 1 zone(s)',
    status: 'closed',
  },
]
